
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const HowItWorks = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>();
  const { ref: stepsRef, visibleItems } = useStaggeredAnimation<HTMLDivElement>(3, 200);

  const steps = [
    {
      number: 1,
      title: "Create Your Account",
      description: "Sign up and complete your profile with business information."
    },
    {
      number: 2,
      title: "List Your Properties",
      description: "Upload property details, add images, and set your pricing."
    },
    {
      number: 3,
      title: "Connect With Buyers",
      description: "Get inquiries from investors and close deals faster."
    }
  ];

  return (
    <section ref={sectionRef} className="py-16 container mx-auto px-4">
      <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
        <h2 className="text-3xl font-bold mb-4">How Go Dyspo <span className="text-godyspo-gold gradient-text">Works</span></h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Our platform simplifies the process of connecting real estate sellers with investors.
        </p>
      </div>

      <div ref={stepsRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
        {steps.map((step, index) => (
          <div 
            key={step.number} 
            className={`text-center transition-all duration-500 ${
              visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'
            }`}
          >
            <div className="h-16 w-16 rounded-full bg-card flex items-center justify-center mx-auto mb-4 border-2 border-godyspo-gold text-godyspo-gold text-2xl font-bold hover-lift hover:animate-bounce-gentle">
              {step.number}
            </div>
            <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
            <p className="text-muted-foreground">
              {step.description}
            </p>
          </div>
        ))}
      </div>

      <div className={`mt-12 text-center transition-all duration-700 delay-300 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
        <Link to="/pricing">
          <Button size="lg" className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90 hover-lift group">
            Start Listing Properties Today
            <span className="ml-2 transition-transform group-hover:translate-x-1">→</span>
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default HowItWorks;
